import { List } from "immutable"
import React = require("react")
import { Teaser } from "./teaser"

export interface GridItem {
  readonly title: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly imageAlt: string
  readonly linkUrl: string
  readonly intro: string
}

export interface GridBlockProps {
  readonly kind: "grid_block"
  items: List<GridItem>
}

export class GridBlock extends React.Component<GridBlockProps, {}> {
  render() {
    const p = this.props

    return (
      <section className="block block--collections collections">
        <div className="block__inner container--lg align--center">
          <ul className="row teasers">
            {p.items.map((item, index) => 
              <Teaser
                key={`grid-item-${index}`}
                title={item.title}
                headingLevel="h2"
                intro={item.intro}
                imageUrl={item.imageUrl}
                imageUrlLarge={item.imageUrlLarge}
                imageAlt={item.imageAlt}
                linkUrl={item.linkUrl}
                extraClasses="block__item col-xs-12 col-sm-6 col-md-3"
              />
            )}
          </ul>
        </div>
      </section>  
    )
  }
}

{/* TH: Added to styleguide! */}
